import React from 'react';

const SignUpContainer = ({...rest}) => {
    return (
        <div>
            sign up page
        </div>
    );
};

export default SignUpContainer;